<template>
    <sys-teacher-hub-modal
        :show.sync="localShow"
        :title="title"
        icon="mdi-clipboard-outline"
    >
        <v-card-text class="pa-4">
            <v-alert
                v-if="!loading && items.length === 0"
                type="info"
                outlined
                class="mb-0"
            >
                Nenhuma atividade cadastrada para este período.
            </v-alert>

            <emc-base-progress-bar v-if="loading" />

            <v-simple-table v-else-if="items.length > 0" dense>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th scope="col">Campus/Departamento</th>
                            <th scope="col">Atividade</th>
                            <th scope="col">Nome</th>
                            <th scope="col">Periodicidade</th>
                            <th scope="col">Tipo</th>
                            <th scope="col" class="text-center">Valor</th>
                            <th scope="col" class="text-center">Compõe CH</th>
                            <th scope="col" class="text-center">Período</th>
                            <th scope="col" class="text-center">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in items" :key="item.id">
                            <td>
                                <span v-if="item.activityItem && item.activityItem.campus">
                                    {{ item.activityItem.campus.name }}
                                </span>
                                <span v-else-if="item.activityItem && item.activityItem.departament">
                                    {{ item.activityItem.departament.name }}
                                </span>
                                <span v-else>-</span>
                            </td>
                            <td>
                                {{ item.activityItem && item.activityItem.activity ? item.activityItem.activity.name : '-' }}
                            </td>
                            <td>
                                {{ item.activityItem ? item.activityItem.name : '-' }}
                            </td>
                            <td>
                                {{ item.activityItem && item.activityItem.periodicityType ? item.activityItem.periodicityType.name : '-' }}
                            </td>
                            <td>
                                {{ item.activityItem && item.activityItem.valueType ? item.activityItem.valueType.name : '-' }}
                            </td>
                            <td class="text-center">{{ item.value || '-' }}</td>
                            <td class="text-center">
                                <v-icon
                                    small
                                    v-if="item.activityItem && item.activityItem.activity && item.activityItem.activity.is_work_load"
                                    color="success"
                                >
                                    mdi-check-bold
                                </v-icon>
                                <v-icon small v-else color="error">mdi-close-thick</v-icon>
                            </td>
                            <td class="text-center text-no-wrap">
                                {{ item.start | date }} - {{ item.end | date }}
                            </td>
                            <td class="text-center">
                                <v-chip
                                    v-if="item.activityItem && item.activityItem.status"
                                    x-small
                                    :color="getStatusColor(item.activityItem.activity_item_status_id)"
                                >
                                    {{ item.activityItem.status.name }}
                                </v-chip>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <v-spacer />
            <v-btn text @click="$emit('update:show', false)">Fechar</v-btn>
        </v-card-actions>
    </sys-teacher-hub-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'SysTeacherMyActivitiesHub',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        teacher: {
            type: Object,
            required: true
        },
        workTime: {
            type: Object,
            default: () => ({})
        },
        token: {
            type: String,
            default: null
        },
        title: {
            type: String,
            default: 'Minhas Atividades'
        }
    },
    data: () => ({
        items: [],
        loading: false
    }),
    computed: {
        localShow: {
            get() { return this.show },
            set(value) { this.$emit('update:show', value) }
        }
    },
    watch: {
        show(value) {
            if (value) this.loadData()
        }
    },
    methods: {
        ...mapActions('teacher', ['ActionFindTeacher']),
        ...mapActions('availability', ['ActionGetTeacherByTokenActivities']),

        async loadData() {
            if (!this.teacher || !this.teacher.id) return

            this.loading = true
            this.items = []

            try {
                const method = this.token ? 'ActionGetTeacherByTokenActivities' : 'ActionFindTeacher'

                const params = {
                    with: 'activities.activityItem.campus,activities.activityItem.departament,activities.activityItem.activity,activities.activityItem.valueType,activities.activityItem.periodicityType,activities.activityItem.status',
                    showAllCampuses: 'true',
                    showAllTeachers: true
                }

                if (this.token) {
                    params.token = this.token
                } else {
                    params.id = this.teacher.id
                }

                const response = await this[method](params)

                if (response.data && response.data.activities) {
                    this.items = response.data.activities.filter(item => {
                        const statusId = item.activityItem?.activity_item_status_id
                        return statusId !== 4 && statusId !== 6
                    })
                }
            } catch (error) {
                console.error('Erro ao carregar atividades:', error)
            } finally {
                this.loading = false
            }
        },

        getStatusColor(statusId) {
            const colors = {
                1: 'warning',
                2: 'info',
                3: 'success',
                4: 'error',
                5: 'grey',
                6: 'error'
            }
            return colors[statusId] || 'grey'
        }
    }
}
</script>

<style scoped>
table td {
    white-space: nowrap;
}
</style>
